<template>
  <button
    @click="togglePlayPause"
    :aria-label="isPlaying ? '暂停' : '播放'"
    :class="`relative flex items-center justify-center w-16 h-16 rounded-full 
    bg-gradient-to-r ${
      isPlaying ? 'from-pink-500 to-orange-500' : 'from-teal-400 to-blue-500'
    }`"
  >
    <div
      class="absolute inset-0 rounded-full bg-gray-400 bg-opacity-10 dark:bg-black dark:bg-opacity-20"
    ></div>
    <transition name="fade" mode="out-in">
      <q-icon
        v-if="!isPlaying"
        name="play_arrow"
        size="lg"
        class="text-white"
      />
      <q-icon v-else name="pause" size="lg" class="text-white" />
    </transition>
    <span class="sr-only">{{ isPlaying ? "暂停" : "播放" }}</span>
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";

interface PlayPauseButtonProps {
  initialState?: boolean;
  onToggle?: (isPlaying: boolean) => void;
}

const props = withDefaults(defineProps<PlayPauseButtonProps>(), {
  initialState: false,
  onToggle: undefined,
});

const isPlaying = ref(props.initialState);

const togglePlayPause = () => {
  isPlaying.value = !isPlaying.value;
  if (props.onToggle) {
    props.onToggle(isPlaying.value);
  }
};

// 暴露组件方法，允许父组件直接控制状态
defineExpose({
  play: () => {
    isPlaying.value = true;
    if (props.onToggle) props.onToggle(true);
  },
  pause: () => {
    isPlaying.value = false;
    if (props.onToggle) props.onToggle(false);
  },
  toggle: togglePlayPause,
  isPlaying,
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>
